import { LayoutDashboard, Table2, Trello } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ViewMode } from '@/types';

const VIEWS: { mode: ViewMode; label: string; icon: typeof Table2 }[] = [
  { mode: 'table', label: 'Tableau', icon: Table2 },
  { mode: 'board', label: 'Board', icon: Trello },
  { mode: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
];

export interface ViewSwitcherProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
  /** Sous-ensemble de vues à afficher (défaut : les trois). */
  views?: ViewMode[];
  className?: string;
}

/**
 * Tabs Table / Board (Kanban) / Dashboard.
 * Brief — composant #7.
 */
export function ViewSwitcher({ value, onChange, views, className }: ViewSwitcherProps) {
  const visible = VIEWS.filter((v) => !views || views.includes(v.mode));
  return (
    <div
      role="tablist"
      aria-label="Mode d'affichage"
      className={cn('inline-flex items-center gap-1 rounded-md border border-border bg-surface-secondary p-1', className)}
    >
      {visible.map(({ mode, label, icon: Icon }) => {
        const active = value === mode;
        return (
          <button
            key={mode}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(mode)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded px-3 py-1.5 text-sm font-semibold transition-colors',
              active
                ? 'bg-brand-accent text-brand-accent-contrast shadow-sm'
                : 'text-content-secondary hover:bg-surface-hover',
            )}
          >
            <Icon className="size-4" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
